import React  from "react";
import { useParams } from 'react-router-dom';
import AnnouncementForm from "./components/AnnouncementForm";

const ViewHoliday = () => {
	const { announcementId } = useParams();
    
	return (
	    <div className="mt-3">
			<AnnouncementForm recordId={announcementId} mode="view"/>
	    </div>
    );
};

export default ViewHoliday;